import { render } from "./Coding.vue?vue&type=template&id=5ef91be8&scoped=true"
import script from "./Coding.vue?vue&type=script&lang=js"
export * from "./Coding.vue?vue&type=script&lang=js"

import "./Coding.vue?vue&type=style&index=0&id=5ef91be8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef91be8"]])

export default __exports__